export const HEADERS = {
    zone :"Zone",
    zone_code:"Zone Code",
    createdByName: "Created By",
    createdOn: "Created On",
    updatedByName: "Modified By",
    updatedOn: "Modified On",
    edit: "Edit / Delete",
}
export const TITLES = {
    add : "Add Zone",
    edit : "Edit Zone"
}
export const FIELDS = {
    zone_code :  {
        title  : "Zone Code",
        placeholder  : "Enter Zone Code"
    },
    zone_name : {
        title : "Zone Name",
        placeholder : "Enter Zone Name"
    },
    states: {
        title : "States",
        placeholder : "Select States"
    }
}